module.exports = __webpack_public_path__ + "static/img/getz_searchfriendsbox_close.92220d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/getz_searchfriendsbox_close.png
// module id = 110
// module chunks = 18